import type { FC } from 'react';

import { Icon, Tile } from '@zen/DesignSystem';
import type { Nullable } from '@zen/utils/typescript';

import { getIconConfig, type Score, type ScoreHintLabels } from './helpers';

const options: Score[] = Array.from({ length: 11 }, (_, index) => index) as Score[];

interface Props {
  hasError: boolean;
  hintLabels?: ScoreHintLabels;
  isDisabled?: boolean;
  onChange: (score: Score) => void;
  value: Nullable<Score>;
}

const ScoreSelect: FC<Props> = (props) => {
  const { hasError, hintLabels, isDisabled, onChange, value } = props;

  return (
    <div data-testid="score-select">
      <div className="flex gap-2 justify-between" data-testid="cargo-variant-select">
        {options.map((score: Score) => {
          const { icon, className } = getIconConfig(score);
          const label: string = score.toString();

          const handleClick = (): void => {
            onChange(score);
          };

          return (
            <Tile
              key={score}
              hasError={hasError}
              isDisabled={isDisabled}
              isSelected={value === score}
              onClick={handleClick}
              title={label}
            >
              <Icon className={`${className} text-xl`} icon={icon} />
            </Tile>
          );
        })}
      </div>
      {hintLabels && (
        <div className="flex justify-between text-xs text-grey-base mt-2">
          <span>{hintLabels.negative}</span>
          <span>{hintLabels.positive}</span>
        </div>
      )}
    </div>
  );
};

export default ScoreSelect;
